<template>
  <Transition v-if="isLoading" name="spinner">
    <div id="cover-spin">
      <span class="loader">
        <span>{{ $spinnerText }}</span>
      </span>
    </div>
  </Transition>

  <v-form :name="props.formProps.formName">
    <Tabs value="0" scrollable>

      <TabList class="mb-4">
        <Tab value="0">{{ __('Basic data') }}</Tab>
      </TabList>

      <TabPanels>
        <TabPanel value="0">
          <div class="grid">
            <FormInputText fieldName="name" label="Role name" validation="required" :isFormDisabled="isFormDisabled"
              :isFocus="true" v-model:field="crud.name" />
          </div>
          <div class="grid">
            <FormMultiselect fieldName="permissions" label="Permissions" showClear :isFormDisabled="isFormDisabled"
              :options="select?.permissions" :filter="(event) => onFilter(event, 'permissions')"
              v-model:field="crud.permissions" />
          </div>
          <div class="grid">
            <FormTextarea fieldName="description" label="Description" row="3" :isFormDisabled="isFormDisabled"
              v-model:field="crud.description" />
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>

    <div class="grid">
      <FormButtons :formProps="props.formProps" :sourceForm="crud" :validation="validation"
        :buttonsVisibility="buttonsVisibility" v-model:isFormDisabled="isFormDisabled">
      </FormButtons>
    </div>
  </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, onFilterService, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormButtons from '@crud/FormButtons.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const options = ['permissions']
const select = ref(null)
const crud = ref({})
const buttonsVisibility = ref(null);

// -----------------------------------------------------

onMounted(async () => {
  await initForm(props, crud, isLoading, options, select, buttonsVisibility)
})

// -----------------------------------------------------

const onFilter = async (event, option) => {
  await onFilterService(event, option, select, isLoading)
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
